<!--
 * @Description: What's this for
 * @Autor: WangYuan
 * @Date: 2021-08-19 15:10:03
 * @LastEditors: Tan Chao
 * @LastEditTime: 2022-09-22 10:54:58
-->
<template>
	<div class="flex flex-wrap row-between">
		<el-select v-model="value" multiple placeholder="请选择" @change="change">
			<el-option v-for="item in list" :key="item.id" :label="item.name" :value="item.id"> </el-option>
		</el-select>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	name: 'GoodsConfigList',
	props: ['value'],

	data() {
		return {
			mValue: 0,
			list: [],
			activeIndex: 0,
		};
	},

	computed: {
		...mapGetters(['curPage', 'curComponent']),
	},

	watch: {
		value: {
			immediate: true,
			deep: true,
			handler(newValue, oldValue) {
				//  this.getList()
			},
		},
	},
	created() {
		// setTimeout(() => {
		console.log(this.curPage.componentList, '当前页面组件');
		console.log(this.curComponent, '当前编辑组件');
		this.getList();
		// }, 800);
	},

	methods: {
		// 获取可选择的组件
		getList() {
			let arr = [];
			this.curPage.componentList.forEach((item, index) => {
				if (item.id == this.curComponent.id) {
					this.activeIndex = index;
				}
				// if (item.component != 'McTabs') {
				arr.push({ name: `${index + 1}.${item.name}`, id: item.id });
				// }
			});
			this.list = arr.slice(this.activeIndex + 1);
			console.log(this.list, this.value);
			if (this.value) {
				this.value = this.value.filter((item) => {
					let show = false;
					this.list.forEach((j) => {
						if (item == j.id) {
							show = true;
						}
					});
					return show;
				});
			}
		},
		getTreeData(data) {
			// 循环遍历json数据
			for (var i = 0; i < data.length; i++) {
				if (data[i].childlist.length < 1) {
					// children若为空数组，则将children设为undefined
					// data[i].childlist=undefined;
					this.list.push(data[i]);
				} else {
					this.list.push(data[i]);
					// children若不为空数组，则继续 递归调用 本方法
					this.getTreeData(data[i].childlist);
				}
			}
			// return data;
		},
		change() {
			console.log(this.value);
			this.$emit('submit', this.value);
		},
		getName() {
			let name = '';
			name = this.list.find((item) => item.id == this.value).name;
			console.log(this.list, this.value);
			return name;
		},
		add() {
			this.$emit('edit');
		},
	},
};
</script>
